
let API_HEADER = '';
let API_LOG = '';
let IMG_HEADER = '';
let VOICE_HEADER = '';

const istest = process.env.NODE_ENV === 'test'

// 生产环境
if (process.env.NODE_ENV === 'production') {
    API_LOG = projectConfig.LOGIN_HEADER || 'http://sso.xyabcd.com/ssoauth'
    API_HEADER = projectConfig.API_HEADER || '/gthmmc/index.php?m=voiceguide&c=index&a='
    IMG_HEADER = projectConfig.IMG_HEADER || ' https://fileserver.xyabcd.com'
    VOICE_HEADER = projectConfig.VOICE_HEADER || 'https://voiceg.xyabcd.com'
} else if (istest) {
    // 测试环境
    API_LOG = 'http://test.ssoauth.com/ssoauth'
    API_HEADER = '/gthmmc/index.php?m=voiceguide&c=index&a='
    IMG_HEADER = 'http://test.fileserver.com'
    VOICE_HEADER = projectConfig.VOICE_HEADER || 'https://voiceg.xyabcd.com'
} else {
    API_LOG = projectConfig.LOGIN_HEADER || 'http://sso.xyabcd.com/ssoauth'
    API_HEADER = projectConfig.API_HEADER || '/gthmmc/index.php?m=voiceguide&c=index&a='
    IMG_HEADER = projectConfig.IMG_HEADER || ' https://fileserver.xyabcd.com'
    VOICE_HEADER = projectConfig.VOICE_HEADER || 'https://voiceg.xyabcd.com'
}

export default {
    logIn: API_LOG + '/oauth/authorize?', //登录
    logOut: API_LOG + '/j_spring_security_logout?redirect_uri=', //登出
    host: API_HEADER,
    getUserInfo: API_HEADER + 'oauthGetUser', // 获取用户信
    getResourceField: API_HEADER + 'getResourcefield', //获取字段资源
    queryDataOfResource: API_HEADER + 'queryDataOfResource', //查询数据资源
    activeStatisticsData: API_HEADER + 'activeStatisticsdata', //统计数据
    modifyDataOfResource: API_HEADER + 'modifyDataOfResource', //修改资源数据
    addDataOfResource: API_HEADER + 'addDataOfResource', //添加资源数据
    deleteDataOfResource: API_HEADER + 'deleteDataOfResource', //删除资源数据 
    queryColumnTree: API_HEADER + 'queryColumnTree', //查询树节点数据
    getImageUrl: IMG_HEADER + '/presignedUrl?filename=', //图片上传
    removeImageUrl: IMG_HEADER + '/removeUploadFile?url=', //删除图片
    // 二维码接口
    // 查询
    getQrcode: API_HEADER + 'getQrcode',
    // 新增
    addQrcode: API_HEADER + 'addQrcode',
    // 修改
    modifyQrcode: API_HEADER + 'modifyQrcode',
    modifyQrcode_new: API_HEADER + 'modifyQrcode_new',
    // 删除
    // 删除
    deleteQrcode: API_HEADER + 'deleteQrcode',
    // 二维码类别
    // 查询
    getQrcodecategory: API_HEADER + 'getQrcodecategory',
    getSynchronize: API_HEADER + 'getSynchronize',
    // 新增
    addQrcodecategory: API_HEADER + 'addQrcodecategory',
    // 修改
    modifyQrcodecategory: API_HEADER + 'modifyQrcodecategory',
    // 删除
    deleteQrcodecategory: API_HEADER + 'deleteQrcodecategory',
    // 二维码统计
    // 查询
    getQrcodestatistics: API_HEADER + 'getQrcodestatistics',
    // 类型访问
    scanQrcode: API_HEADER + 'scanQrcode',
    // 图片上传
    imageUpload: IMG_HEADER + '/presignedUrl?sysName=emercontrol',
    removeImageUpload: IMG_HEADER + '/removeUploadFile?sysName=emercontrol',
    VOICE_HEADER: VOICE_HEADER,
};